import fetch from '@/common/utils/serFetch'
import { APICUS } from '@public/utils/const'

// 报表 历史会话记录
export const HistoricalConversation = {
  signIn: params => fetch.post(`${APICUS}/staffRegistrationRecord/login`, params)
}

// 报表 客服会话查询
export const CustomerSessionQuery = {
  signIn: params => fetch.post(`${APICUS}/staffSession/login`, params)
}

// 报表 服务商会话查询
export const ServiceProviderSessionQuery = {
  signIn: params => fetch.post(`${APICUS}/staffSession/service/login`, params)
}
export const LargeScreenBoardHq = {
  // 列表获取
  getData(params) {
    return fetch.get(`${APICUS}/xuanMi/hq/largeScreenDisplay`, { params })
  }
}
